<template>
<v-card-text class="slide_wrapper_item">
  <span>{{title}}</span>
  <v-slider
    class="slide_wrapper_item_cap"
    v-model="values"
    step="1"
    tick-size="1"
    min="-1"
    max="1"
    :color="getColor()"
    :track-color="getColor()"
  />
</v-card-text>
</template>
<script>
export default {
  name: 'Slider',
  data:()=>({}),
  props:{
    title: {type: String, default: 'Описание'},
    value: {type: Number},
  },
  computed: {
    values: {
      get(){return this.value},
      set(val){this.$emit('input',val)}
    }
 },
 methods: {
   getColor(){
     //#1867c0 def color
     if(this.value > 0){
       return 'green'
     }
     if(this.value < 0){
       return 'red'
     }
     if(this.value === 0){
       return 'gray'
     }
   }
 }
}
</script>
